import { render } from "./04_BusinessSection.vue?vue&type=template&id=c18fc214&scoped=true"
import script from "./04_BusinessSection.vue?vue&type=script&lang=js"
export * from "./04_BusinessSection.vue?vue&type=script&lang=js"

import "./04_BusinessSection.vue?vue&type=style&index=0&id=c18fc214&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c18fc214"]])

export default __exports__